import { useEffect, useState, useCallback, Fragment } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'
import Image from 'next/image'
import dayjs from 'dayjs'
import axios from 'axios'
import { Spin, DatePicker } from 'antd'
import Icon from 'src/@core/components/icon'
import Head from 'next/head'

import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'
import { getAllDashboard } from '/src/@api/dashboard'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import { useTranslation } from 'src/utils/i18n'
import RangePickerBox from 'src/components/RangePickerBox'
import { styled } from '@mui/material/styles'
import ContentLoading from 'src/components/ContentLoading'
import { buildTimeParams, toMillis } from 'src/utils/dateRangeParams'

const { RangePicker } = DatePicker

const CustomRangePicker = styled(RangePicker)`
  .ant-picker-input {// 包裹显示两个时间input的div样式
    width:auto;
  }
  .ant-picker-input > input {// 显示两个时间的input样式
    font-family: Poppins !important;
    font-weight: 400 !important;
    line-height: 24px !important;
    font-size: 16px !important;
    text-align: center;
    text-overflow: clip !important;  /* 禁止使用省略号 */
    overflow: visible !important;    /* 允许文本溢出 */
  }
  .ant-picker-input input[date-range="start"] {
  width: var(--firstWidth) !important;
  }
  .ant-picker-input input[date-range="end"] {
    width: var(--lastWidth) !important;
  }
  .ant-picker-input > input::placeholder {// 显示两个时间的placeholder样式（占位符
    color:#ADADAD;
  }
  .ant-picker-suffix {// 框内icon样式
    order:-1;
    opacity:1 !important;
    margin-right:11px;
  }
  `

const ScrollDiv = styled('ul')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

const Mail = () => {
  const { t } = useTranslation('common') // 使用 i18next 进行国际化

  const readUsername = () => JSON.parse(localStorage.getItem('DeviceUser'))?.username || ''

  // 状态声明
  const [mailBoxes, setMailBoxes] = useState(1) // 移动端显示层级
  const [boxes, setBoxes] = useState([]) // 获取第一层数据
  // 获取第二层数据
  const [emailListPage, setEmailListPage] = useState(1) // 当前邮件列表页码
  const [emailList, setEmailList] = useState([]) // 当前显示的邮件列表
  const [emailListId, setMailListId] = useState(0) // 当前选中的邮件列表ID
  const [emailListTotal, setEmailListTotal] = useState(0) // 邮件总数
  const [currentClickType, setCurrentClickType] = useState('') // 当前选中的文件夹名称
  // 获取第三层数据
  const [emailInfoId, setEmailInfoId] = useState([]) // 当前选中的邮件ID
  const [emailInfoContent, setEmailInfoContent] = useState([]) // 当前邮件详细信息
  const [loading, setLoading] = useState(false) // 加载状态
  const dispatch = useDispatch()
  const [antdSelectedDates, setAntdSelectedDates] = useState([])
  const [selectedDateIndex, setSelectedDateIndex] = useState()

  //筛选过的消息列表
  const [dateMessageList, setDateMessageList] = useState([])
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 将文件夹数据转换为嵌套结构
  const convertToNestedStructure = inputData => {
    const result = []
    inputData.forEach(folder => {
      const pathComponents = folder.displayName.split('/')
      let currentLevel = result
      pathComponents.forEach(component => {
        let existingFolder = currentLevel.find(item => item.displayName === component)
        if (!existingFolder) {
          existingFolder = {
            displayName: component,
            identifier: folder.identifier,
            messageCount: folder.messageCount,
            children: []
          }
          currentLevel.push(existingFolder)
        }
        currentLevel = existingFolder.children
      })
    })

    return result
  }

  // 渲染嵌套的文件夹结构
  const renderNested = (folders, level = 0) => (
    <ul style={{ paddingLeft: `${level * 4}px`, listStyleType: 'none' }}>
      {folders.map(folder => (
        <li
          key={folder.identifier}
          style={{
            width: '100%',
            height: '34px',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '21px',
            marginBottom: '10px',
            cursor: 'pointer',
            paddingLeft: `${level * 1}px`,
            color: 'rgba(0, 0, 0, 0.88)',
            borderRadius: '6px',
            position: 'relative',
            paddingTop: '7px',
            paddingLeft: '10px',
            background: emailListId === folder.identifier ? '#E7E7E9' : '',
            borderBottom: window.innerWidth >= 1000 ? '1px solid #E4E4E6 !important' : ''
          }}
          onClick={e => getMailSummary(e, folder)}
        >
          <Image
            src={emailListId === folder.identifier ? '/images/mail/mail-folder1.svg' : '/images/mail/mail-folder2.svg'}
            width={20}
            height={20}
            alt='img'
            priority
            style={{ display: 'inline-block', verticalAlign: 'middle' }}
          />
          &nbsp;&nbsp;
          <span className=''>{folder.displayName}</span>
          <span style={{ position: 'absolute', right: '4px' }}>
            <Icon icon='material-symbols:chevron-right-rounded' color='#C5C5C7' />
          </span>
          {folder.children && renderNested(folder.children, level + 1)}
        </li>
      ))}
    </ul>
  )

  // 按「当前文件夹 + 当前日期区间」重新拉取邮件列表（日期由接口筛选）
  const reloadMailList = useCallback(
    async range => {
      if (!emailListId) return

      try {
        const result = await getAllDashboard({
          username: readUsername(),
          params: {
            category: 'MAIL_SESSION_SUMMARY',
            rid: String(emailListId),
            offset: 0,
            limit: 1000,
            ...buildTimeParams(range)
          }
        })

        setEmailListTotal(result.data.totalCount)

        const map = (result.data.contents || []).map(row => ({
          ...row,
          date: dayjs(row.date).format('YYYY-MM-DD'),
          name: row.from ? row.from[0].split('<')[0].trim().replace(/"/g, '') : ''
        }))

        setDateMessageList(map)
        setEmailList(map)
      } catch (error) {
        console.error('按日期筛选邮件失败:', error)
      }
    },
    [emailListId]
  )

  //选择日期范围
  const handleDateChange = (dates, dateStrings) => {
    const picked = dates && dates.length === 2 ? dates : []

    setAntdSelectedDates(picked)
    setSelectedDateIndex(picked.length === 2 ? 2 : 1)

    reloadMailList(picked)
  }

  // 获取邮件文件夹
  const getBoxes = useCallback(async () => {
    try {
      const result = await getAllDashboard({
        username: readUsername(),
        params: {
          category: 'MAIL_FOLDER',
          offset: 0,
          limit: 100
        }
      })

      const data = convertToNestedStructure(result.data.contents || [])
      setBoxes(data)
    } catch (error) {
      console.error('获取文件夹信息失败:', error)
    }
    setIsLoading(false)
  }, [])

  // 获取邮件摘要信息
  const getMailSummary = useCallback(
    async (e, row, mode) => {
      try {
        if (!mode) {
          setMailBoxes(2) // 切换到邮件列表视图
        }

        //静止冒泡
        e.stopPropagation()
        const result = await getAllDashboard({
          username: readUsername(),
          params: {
            category: 'MAIL_SESSION_SUMMARY',
            rid: String(row.identifier),
            offset: (emailListPage - 1) * 10,
            limit: 1000,
            // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
            ...buildTimeParams(antdSelectedDates)
          }
        })
        setEmailListTotal(result.data.totalCount)
        setCurrentClickType(row.displayName)
        setMailListId(row.identifier)
        setEmailListPage(1)
        localStorage.setItem('icloudMailListId', row.identifier)

        if (result.data.contents) {
          const map = result.data.contents.map(row => ({
            ...row,
            date: dayjs(row.date).format('YYYY-MM-DD'),
            name: row.from ? row.from[0].split('<')[0].trim().replace(/"/g, '') : '',
            content: row.content ? row.content[0].trim() : ''
          }))
          setDateMessageList(map)
          setEmailList(map)
        } else {
          setEmailList([])
        }
      } catch (error) {
        console.error('获取邮件摘要信息失败:', error)
      }
    },
    [emailListPage]
  )

  // 获取邮件详细信息
  const getEmailInfo = async id => {
    try {
      // 在移动端进入第三层数据
      setMailBoxes(3)

      // 写入id
      setEmailInfoId(id)

      const result = await getAllDashboard({
        username: readUsername(),
        params: {
          category: 'MAIL_SESSION',
          rid: String(id)
        }
      })
      const contents = result.data.contents
      if (contents && contents.mails) {
        const updatedMails = await Promise.all(
          contents.mails.map(async mail => {
            const contentText = await axios.get(`https://cos.spyx.com/${mail.url}`)
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = contentText.data
              ;[...tempDiv.getElementsByTagName('style')].forEach(styleTag => styleTag.parentNode.removeChild(styleTag))

            return {
              ...mail,
              fromName: mail.from[0].split('<')[0].trim().replace(/"/g, ''),
              toName: mail.to[0].split('<')[0].trim().replace(/"/g, ''),
              time: dayjs(mail.date).format('YYYY-MM-DD'),
              info: tempDiv.innerHTML
            }
          })
        )
        setEmailInfoContent(updatedMails)
      }
    } catch (error) {
      console.error('获取邮件详细信息失败:', error)
    }
  }

  // 处理滚动事件以加载更多邮件
  const handleScroll = useCallback(() => {
    const ulElement = document.getElementById('email-list')
    if (ulElement && !loading) {
      const isAtBottom = ulElement.scrollHeight - ulElement.scrollTop <= ulElement.clientHeight + 1
      if (isAtBottom) {
        setLoading(true)
        setEmailListPage(prevPage => prevPage + 1)
      }
    }
  }, [loading])

  // 添加滚动事件监听器
  useEffect(() => {
    const emailListElement = document.getElementById('email-list')
    if (emailListElement) {
      emailListElement.addEventListener('scroll', handleScroll)

      return () => emailListElement.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  // 加载更多邮件数据
  useEffect(() => {
    const loadMoreData = async () => {
      try {
        if (emailListTotal === emailList.length) {
          setLoading(false)

          return
        }
        const result = await getAllDashboard({
          username: readUsername(),
          params: {
            category: 'MAIL_SESSION_SUMMARY',
            rid: String(emailListId),
            offset: (emailListPage - 1) * 10,
            limit: 1000,
            ...buildTimeParams(antdSelectedDates)
          }
        })
        setEmailListTotal(result.data.totalCount)
        if (result.data.contents) {
          const map = result.data.contents.map(row => ({
            ...row,
            date: dayjs(row.date).format('YYYY-MM-DD'),
            name: row.from ? row.from[0].split('<')[0].trim().replace(/"/g, '') : ''
          }))
          setDateMessageList(map)
          // 没选日期时必须原样保留（原来会把 startTime 算成 undefined，导致翻页永远追加不到数据）
          const { startTime, endTime } = buildTimeParams(antdSelectedDates)
          const filteredMap =
            startTime == null || endTime == null
              ? map
              : map.filter(item => {
                  const itemTime = toMillis(item.date)

                  return itemTime >= startTime && itemTime <= endTime
                })
          setEmailList(prevList => prevList.concat(filteredMap))
        }
        setLoading(false)
      } catch (error) {
        console.error('加载更多邮件失败:', error)
        setLoading(false)
      }
    }
    loadMoreData()
  }, [emailListPage, emailListId])

  // 根据日期范围更新邮件列表
  useEffect(() => {
    if (boxes.length > 0) {
      const currentFolder = boxes.find(folder => folder.identifier === emailListId)
      if (currentFolder) {
        getMailSummary({ stopPropagation: () => { } }, currentFolder, true)
      }
    }
  }, [boxes, emailListId, getMailSummary])

  // 设备切换时重置邮件视图并重新拉数
  useDeviceScopedInit(
    useCallback(() => {
      setMailBoxes(1)
      setBoxes([])
      setEmailListPage(1)
      setEmailList([])
      setMailListId(0)
      setEmailListTotal(0)
      setCurrentClickType('')
      setEmailInfoId([])
      setEmailInfoContent([])
      setDateMessageList([])
      setIsLoading(true)
      getBoxes()
    }, [getBoxes])
  )

  // 设置当前选项卡
  useEffect(() => {
    dispatch(setCurrentTab(t('Mail')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch])

  // 获取今天的日期
  const today = dayjs().format('YYYY-MM-DD')

  // 获取七天前的日期
  const sevenDaysAgo = dayjs().subtract(7, 'day').format('YYYY-MM-DD')

  // 获取最宽日期选择器占位符宽度
  useEffect(() => {

    // 开始时间&结束时间
    let firstDate = '0000-00-00'
    let lastDate = '0000-00-00'

    // 开始时间宽度&结束时间宽度
    let firstWidth = 0
    let lastWidth = 0

    const span = document.createElement('span')
    span.style.setProperty('font-family', 'Poppins', 'important')
    span.style.setProperty('font-size', '16px', 'important')
    span.style.setProperty('font-weight', '400', 'important')
    span.style.setProperty('line-height', '24px', 'important')
    span.style.visibility = 'hidden'
    span.innerText = firstDate

    // 获取第一个占位符宽度
    document.body.appendChild(span)
    firstWidth = span.offsetWidth
    document.body.removeChild(span)

    // 获取第二个占位符宽度
    span.innerText = lastDate
    document.body.appendChild(span)
    lastWidth = span.offsetWidth
    document.body.removeChild(span)

    // 插入至html标签样式中用于调用
    document.documentElement.style.setProperty('--firstWidth', `${firstWidth}px`)
    document.documentElement.style.setProperty('--lastWidth', `${lastWidth}px`)
  }, [])


  return (
    <>
      <Head>
        <meta name="format-detection" content="telephone=no" />
      </Head>
      {isLoading ? (
        <div className='relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] flex'>
          <ContentLoading />
        </div>
      ) : (
      <>
      {/* pc端 */}
      <div
        className='relative flex Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] rounded-[10px] smj:hidden'
        style={{ boxShadow: '0px 2px 10px 0px rgba(76, 78, 100, 0.22)' }}
      >
        <div
          style={{
            width: '20%',
            height: '100%',
            background: '#F9F9FF',
            borderRight: '1px solid #D8D8DA',
            padding: '10px',
            overflow: 'auto',
            paddingRight: '0px',
            position: 'relative'
          }}
        >
          {renderNested(boxes)}
          {(boxes.length > 0 || isLoading) ||
            <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
              {t('It appears theres no data to show here yet')}<br />
              {t('If data exists it may take up to 1 hour to download and appear')}<br />
              {t('We suggest checking back in a little while')}
            </div>}
        </div>
        <div
          style={{
            width: '25%',
            height: '100%',
            background: '#fff',
            borderRight: '1px solid #D8D8DA',
            paddingLeft: '10px',
            paddingright: '10px',
            paddingTop: '8px'
          }}
          className='Hsm:hidden'
        >
          <h2
            style={{
              marginLeft: '8px',
              fontWeight: '600',
              fontSize: '18px',
              lineHeight: '27px',
              paddingLeft: '8px',
              color: '#000000'
            }}
          >
            {currentClickType}
          </h2>
          <p
            style={{
              marginLeft: '8px',
              color: '#A9A9A9',
              fontWeight: '400',
              fontSize: '12px',
              lineHeight: '18px',
              paddingLeft: '8px'
            }}
          >
            {emailListTotal} {t('Email')}
          </p>
          <ul
            id='email-list'
            style={{ marginTop: '22px', height: 'calc(100% - 80px)', overflowY: 'auto', paddingright: 0 }}
          >
            {emailList.map((row, i) => (
              <li
                key={i}
                style={{
                  borderBottom: '1px solid #E4E4E6',
                  padding: '10px 4px',
                  cursor: 'pointer',
                  borderRadius: emailInfoId === row.id ? '6px' : '0px',
                  background: emailInfoId === row.id ? '#E4E4E6' : ''
                }}
                onClick={() => getEmailInfo(row.id)}
              >
                <div style={{ paddingLeft: '3px', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px', color: '#000000' }}>
                    {row.name}
                  </span>
                  <span style={{ color: '#808080', fontSize: '12px', paddingRight: '3px' }}>{row.date}</span>
                </div>
                <div
                  style={{
                    paddingLeft: '3px',
                    fontWeight: '400',
                    fontSize: '13px',
                    lineHeight: '19.5px',
                    color: '#222222'
                  }}
                >
                  {row.name}
                </div>
                <div
                  style={{
                    paddingLeft: '3px',
                    color: '#808080',
                    fontSize: '13px',
                    fontWeight: '400',
                    wordWrap: 'break-word',
                    lineHeight: '19px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: '2'
                  }}
                >
                  {row.subject}
                </div>
              </li>
            ))}
          </ul>
          {loading && (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Spin />
            </div>
          )}
        </div>
        <div style={{ width: '55%', background: '#fff', overflow: 'auto' }} className='Hsm:hidden'>
          {emailInfoContent.map((row, i) => (
            <div key={i}>
              <div
                style={{
                  height: '96px',
                  borderBottom: '1px solid #E4E4E6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '36px' }}>
                  <div
                    style={{
                      width: '40px',
                      height: '40px',
                      background: '#A6A6AA',
                      borderRadius: '50%',
                      textAlign: 'center',
                      lineHeight: '40px',
                      fontWeight: '600',
                      fontSize: '20px',
                      color: '#fff',
                      marginRight: '14px'
                    }}
                  >
                    {row.fromName.substr(0, 1)}
                  </div>
                  <div>
                    <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px' }}>{row.fromName}</p>
                    <p style={{ fontWeight: '600', fontSize: '12px', lineHeight: '18px' }}>{row.getAllDashboard}</p>
                    <p style={{ fontSize: '14px' }}>
                      <span>{t('Receipt')}:</span> <span style={{ color: 'rgba(0, 0, 0, 0.48)' }}>{row.toName}</span>
                    </p>
                  </div>
                </div>
                <div style={{ color: 'rgba(0, 0, 0, 0.56)', fontSize: '14PX', marginRight: '36px' }}>{row.time}</div>
              </div>
              <div style={{ overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: row.info }} />
            </div>
          ))}
        </div>
      </div>

      {/* 移动端 */}
      <div
        className={`relative bg-[#FFF] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] h-[calc(var(--vh2)*100-90px)] smj:!h-[calc(var(--vh2)*100-86px)] m-auto hidden smj:flex flex-col`}
      >
        {mailBoxes === 1 && (
          <div
            style={{ width: '100%', height: '100%', background: '#FFF', padding: '17px 0px 10px 16px', overflow: 'auto' }}
            className='rounded-[10px]'
          >
            <p className='text-[18px] leading-[27px] font-[600]'>iCloud</p>

            <ul>
              {
                boxes.map(item => (
                  <li key={item.identifier} className='flex items-center' onClick={e => getMailSummary(e, item)}>
                    <Image
                      src={emailListId === item.identifier ? '/images/mail/mail-folder1.svg' : '/images/mail/mail-folder2.svg'}
                      width={20}
                      height={20}
                      alt='img'
                      priority
                      className='inline-block align-middle'
                    />

                    <div className='w-full flex items-center ml-[14.5px] py-4 [border-bottom:0.5px_solid_#E5E7EB]'>
                      <p className='text-[16px] font-[500] leading-[24px]'>{item.displayName}</p>
                      <div className='flex items-center absolute right-1'>
                        <p className='text-[14px] font-[400] leading-[21px] text-[#BABABE]'>{item.messageCount > 0 && item.messageCount}</p>&nbsp;
                        <Icon icon='material-symbols:chevron-right-rounded' color='#C5C5C7' />
                      </div>
                    </div>
                  </li>
                ))
              }
            </ul>

            {/* {renderNested(boxes)} */}
          </div>
        )}
        {mailBoxes === 2 && (
          <>
            <div>
              <div style={{ display: 'flex', color: '#000000', margin: 'auto' }} className='py-[21px] w-[90%]'>
                <Icon icon='ion:chevron-back' onClick={() => setMailBoxes(1)} />{' '}
                <span
                  style={{
                    textAlign: 'center',
                    fontSize: '18px',
                    lineHeight: '27px',
                    fontWeight: '500',
                    margin: 'auto'
                  }}
                >
                  {currentClickType}
                </span>
                <div className='w-[24px] h-[24px]'></div>
              </div>
              {/*时间选择器*/}
              {emailList && (
                <Fragment>
                  {/* <RangePickerBox
                    value={antdSelectedDates}
                    onChange={handleDateChange}
                    onClear={() => {
                      setAntdSelectedDates([])
                      handleDateChange([])
                    }}
                  /> */}

                  {/* 新ui */}
                  <div className='w-full px-[15px] mb-2'>
                    <CustomRangePicker
                      format="YYYY-MM-DD" // 左右两边显示的日期格式
                      placeholder={[sevenDaysAgo, today]} // 默认显示占位符
                      separator={<span className={`text-[#ADADAD]`}>~</span>} // 两个日期的间隔符
                      suffixIcon={<Image src="/images/calls/calendar.svg" alt='calendar' width={18} height={18} />} // 替换默认icon
                      className='w-full h-[40px] bg-[#F8F8F8]'
                      inputReadOnly={true} // 禁用手机弹出输入法 true为不允许弹出
                      // allowClear={false} // 清除按钮是否显示
                      onChange={handleDateChange}
                    />
                  </div>
                </Fragment>
              )}
            </div>
            {/* <ul id='email-list' style={{ marginTop: '6px' }} className=' overflow-auto'>
              {emailList.map((row, i) => (
                <li
                  key={i}
                  className='py-[10px] w-[90%] m-auto'
                  style={{
                    borderBottom: '1px solid #E4E4E6',
                    cursor: 'pointer',
                    borderRadius: emailInfoId === row.id ? '6px' : '0px',
                    background: emailInfoId === row.id ? '#E4E4E6' : ''
                  }}
                  onClick={() => getEmailInfo(row.id)}
                >
                  <div style={{ paddingLeft: '3px', display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px', color: '#000000' }}>
                      {row.name}
                    </span>
                    <span style={{ color: '#808080', fontSize: '12px', paddingRight: '3px' }}>{row.date}</span>
                  </div>
                  <div style={{ paddingLeft: '3px', fontWeight: '400', fontSize: '13px', color: '#222222' }}>
                    {row.name}
                  </div>
                  <div
                    style={{
                      paddingLeft: '3px',
                      color: '#808080',
                      fontSize: '13px',
                      fontWeight: '400',
                      wordWrap: 'break-word',
                      lineHeight: '19px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: '2'
                    }}
                  >
                    {row.subject}
                  </div>
                </li>
              ))}
            </ul> */}

            {/* 新ui */}
            <ScrollDiv id='email-list' className='w-full px-[15px] overflow-auto'>
              {emailList.map((row, i) => (
                <li
                  key={i}
                  className='w-full py-[8px]'
                  style={{
                    borderBottom: '1px solid #E5E7EB',
                    cursor: 'pointer'
                  }}
                  onClick={() => getEmailInfo(row.id)}
                >
                  <div style={{ paddingLeft: '3px', display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px', color: '#000000' }}>{row.name}</p>
                    <p style={{ fontWeight: '400', color: '#808080', fontSize: '12px', lineHeight: '18px', paddingRight: '3px' }}>{dayjs(row.date).format('YYYY/MM/DD')}</p>
                  </div>
                  <div style={{ fontWeight: '400', paddingLeft: '3px', fontSize: '13px', lineHeight: '19.5px', color: '#222222' }}>
                    <p>{row.name}</p>
                  </div>
                  <div
                    style={{
                      paddingLeft: '3px',
                      color: '#808080',
                      fontSize: '13px',
                      fontWeight: '400',
                      wordWrap: 'break-word',
                      lineHeight: '19px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: '2'
                    }}
                  >
                    <p>{row.subject}</p>
                  </div>
                </li>
              ))}
            </ScrollDiv>

            {loading && (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spin />
              </div>
            )}
          </>
        )}
        {mailBoxes === 3 && (
          <>
            {emailInfoContent.map((row, i) => (
              <div key={i} className='h-[calc(var(--vh2)*100-90px)] smj:!h-[calc(var(--vh2)*100-86px)] flex flex-col'>
                <div
                  style={{ display: 'flex', color: '#000000', margin: 'auto', paddingLeft: '16px' }}
                  className='py-[21px] w-[100%]'
                >
                  <Icon icon='ion:chevron-back' onClick={() => setMailBoxes(2)} />{' '}
                  <span
                    style={{
                      textAlign: 'center',
                      fontSize: '18px',
                      lineHeight: '27px',
                      fontWeight: '600',
                      margin: 'auto'
                    }}
                  ></span>
                  <div className='w-[24px] h-[24px]'></div>
                </div>

                {/* <div
                  style={{
                    width: '100%',
                    margin: 'auto',
                    height: '58px',
                    borderBottom: '1px solid #E4E4E6',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '16px',
                    paddingBottom: '13px'
                  }}
                >
                  <div
                    style={{
                      width: '40px',
                      height: '40px',
                      background: '#A6A6AA',
                      borderRadius: '50%',
                      textAlign: 'center',
                      lineHeight: '40px',
                      fontWeight: '600',
                      fontSize: '20px',
                      color: '#fff',
                      marginRight: '14px'
                    }}
                  >
                    {row.fromName.substr(0, 1)}
                  </div>
                  <div className='flex-1'>
                    <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center' }}>
                      <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px' }}>{row.fromName}</p>
                      <p style={{ color: 'rgba(0, 0, 0, 0.56)', fontSize: '14PX', paddingRight: '12px' }}>{row.time}</p>
                    </div>
                    <p style={{ fontSize: '14px' }}>
                      <span>{t('Receipt')}:</span> <span style={{ color: 'rgba(0, 0, 0, 0.48)' }}>{row.toName}</span>
                    </p>
                  </div>
                </div> */}
                {/* <div className='flex-1 overflow-auto rounded-[10px]' dangerouslySetInnerHTML={{ __html: row.info }} /> */}

                {/* 新ui */}
                <div
                  style={{
                    width: '100%',
                    margin: 'auto',
                    height: 'auto',
                    borderBottom: '1px solid #E4E4E6',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '16px',
                    paddingBottom: '12px'
                  }}
                >
                  <div
                    style={{
                      width: '35px',
                      height: '35px',
                      background: 'linear-gradient(180deg, #A5AAB6 0%, #868A93 100%)',
                      borderRadius: '50%',
                      textAlign: 'center',
                      lineHeight: '24px',
                      fontWeight: '500',
                      fontSize: '16px',
                      color: '#fff',
                      marginRight: '14px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    {row.fromName.split(' ').map(word => word[0]).join('')}
                  </div>
                  <div className='flex-1'>
                    <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'start' }}>
                      <p style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px', maxWidth: '65%', wordBreak: 'break-all' }}>{row.fromName}</p>
                      <p style={{ color: 'rgba(0, 0, 0, 0.56)', fontSize: '14PX', lineHeight: '21px', paddingRight: '12px' }}>{dayjs(row.time).format('YYYY/MM/DD')}</p>
                    </div>
                    <div style={{ fontSize: '14px', lineHeight: '21px', fontWeight: '400', display: 'flex', alignItems: 'start' }}>
                      <p>{t('Receipt')}:</p>&nbsp;
                      <p className='text-[#959595] max-w-[55%] break-all'>
                        {row.toName}
                        <Image src='/images/mail/mailunion.svg' width={7} height={7} className='inline-block ml-2' />
                      </p>
                    </div>
                  </div>
                </div>
                <div className='flex-1 overflow-auto rounded-[10px]' dangerouslySetInnerHTML={{ __html: row.info }} />
              </div>
            ))}
          </>
        )}
      </div>
      {/* 结束pc */}

      {(boxes.length > 0 || isLoading) ||
        <div className='text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none smjs:hidden'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>}
      </>
      )}
    </>
  )
}

export default Mail

// 静态属性获取

